"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EdgeType = exports.PinType = exports.PinDirection = exports.VariableScope = exports.VariableType = void 0;
/**
 * Enum defining the types of variables that can be used in workflows
 */
var VariableType;
(function (VariableType) {
    VariableType["STRING"] = "string";
    VariableType["NUMBER"] = "number";
    VariableType["BOOLEAN"] = "boolean";
    VariableType["OBJECT"] = "object";
    VariableType["ARRAY"] = "array";
    VariableType["DATE"] = "date";
    VariableType["NULL"] = "null";
    VariableType["UNKNOWN"] = "unknown";
})(VariableType = exports.VariableType || (exports.VariableType = {}));
/**
 * Enum defining the scope of workflow variables
 */
var VariableScope;
(function (VariableScope) {
    VariableScope["GLOBAL"] = "global";
    VariableScope["LOCAL"] = "local";
    VariableScope["TEMPORARY"] = "temporary";
})(VariableScope = exports.VariableScope || (exports.VariableScope = {}));
/**
 * Enum defining the direction of node pins
 */
var PinDirection;
(function (PinDirection) {
    PinDirection["INPUT"] = "input";
    PinDirection["OUTPUT"] = "output";
})(PinDirection = exports.PinDirection || (exports.PinDirection = {}));
/**
 * Enum defining the type of node pins
 */
var PinType;
(function (PinType) {
    PinType["EXECUTION"] = "execution";
    PinType["DATA"] = "data";
})(PinType = exports.PinType || (exports.PinType = {}));
/**
 * Enum defining the type of workflow edges
 */
var EdgeType;
(function (EdgeType) {
    EdgeType["EXECUTION"] = "execution";
    EdgeType["DATA"] = "data";
})(EdgeType = exports.EdgeType || (exports.EdgeType = {}));
